'use strict';

var _regeneratorRuntime = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var errors = require('../errors');

var repoInit = require('./init');

var Datastore = require('datastore-fs');

var Key = require('interface-datastore').Key;

var versionKey = new Key('version');
exports.getVersion = getVersion;
/**
 * Function that has responsibility to retrieve version of repo from its root datastore's instance.
 * This function needs to be cross-repo-version functional to be able to fetch any version number,
 * even in case of change of repo's versioning.
 *
 * @param {string} path
 * @returns {Promise<int>}
 */

function getVersion(_x) {
  return _getVersion.apply(this, arguments);
}
/**
 * Function for setting a version in cross-repo-version manner.
 *
 * @param {string} path
 * @param {int} version
 * @returns {Promise<void>}
 */


function _getVersion() {
  _getVersion = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(path) {
    var store, version;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return repoInit.isRepoInitialized(path);

          case 2:
            if (_context.sent) {
              _context.next = 4;
              break;
            }

            throw new errors.NotInitializedRepoError("Repo in path ".concat(path, " is not initialized!"));

          case 4:
            store = new Datastore(path, {
              extension: '',
              createIfMissing: false
            });
            _context.next = 7;
            return store.open();

          case 7:
            _context.t0 = parseInt;
            _context.next = 10;
            return store.get(versionKey);

          case 10:
            _context.t1 = _context.sent;
            version = (0, _context.t0)(_context.t1);
            _context.next = 14;
            return store.close();

          case 14:
            return _context.abrupt("return", version);

          case 15:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _getVersion.apply(this, arguments);
}

function setVersion(_x2, _x3) {
  return _setVersion.apply(this, arguments);
}

function _setVersion() {
  _setVersion = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(path, version) {
    var store;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            store = new Datastore(path, {
              extension: '',
              createIfMissing: false
            });
            _context2.next = 3;
            return store.open();

          case 3:
            _context2.next = 5;
            return store.put(versionKey, Buffer.from(String(version)));

          case 5:
            _context2.next = 7;
            return store.close();

          case 7:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _setVersion.apply(this, arguments);
}

exports.setVersion = setVersion;